import { useLayoutEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { cn } from 'utils/className';

export const AnimatedWizardOutlet = () => {
  const location = useLocation();
  const [renderKey, setRenderKey] = useState(location.pathname);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const className = cn('motion-opacity-in-0', {
    'motion-translate-x-in-100 motion-duration-300 motion-ease-out':
      !isFirstRender,
  });

  useLayoutEffect(() => {
    if (location.pathname !== renderKey) {
      setRenderKey(location.pathname);
      setIsFirstRender(false);
    }
  }, [location.pathname, renderKey]);

  return (
    <div key={renderKey} className={className}>
      <Outlet />
    </div>
  );
};
